import { cornerRadius } from "@bug-on/m3-tokens";

/**
 * MD3 Expressive Button Group Tokens
 * Ported from ButtonGroupSmallTokens.kt and ConnectedButtonGroupSmallTokens.kt
 */
export const BUTTON_GROUP_TOKENS = {
	standard: {
		betweenSpace: 12, // 12dp / 0.75rem / gap-3
		containerHeight: 40, // 40dp / 2.5rem
	},
	connected: {
		betweenSpace: 2, // 2dp / 0.125rem / gap-0.5
		containerHeight: 40, // 40dp / 2.5rem
		containerShape: cornerRadius.full, // 9999px
		innerCorner: cornerRadius.small, // 8dp
		pressedInnerCorner: cornerRadius.extraSmall, // 4dp
		selectedCornerPercent: 50, // 50% -> full pill
	},
} as const;
